import React from "react";
import { Box, IconButton, Typography, Skeleton } from "@mui/material";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Link } from "react-router-dom";
import { ContainerBox, PaitentContainer, RowContainer } from "./styles";

// const logos = {
//   "Stellar Health":
//     "https://orcicare-static.s3.us-east-1.amazonaws.com/images/vendor/stellar_health_logo.cb1ec1b759bd.svg",
//   Aledade:
//     "https://orcicare-static.s3.us-east-1.amazonaws.com/images/vendor/Aledade-Logo_Blue-1-300x60.png",
// };

const Widget = ({ title, status, paitents = 0, source, isLoading, data }) => {
  return (
    <ContainerBox>
      <Box>
        {isLoading ? (
          <>
            <Skeleton variant="text" width={150} height={28} />
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </>
        ) : (
          <>
            <Typography fontSize={18} fontWeight={400}>
              {title}
            </Typography>
            <Typography fontSize={14} fontWeight={400}>
              <strong>Status:</strong> {status}
            </Typography>
            {/* <Typography fontSize={14} fontWeight={400}>
              <strong>Source:</strong>{" "}
              {logos[source] ? (
                <img
                  src={logos[source]}
                  alt={source}
                  style={{ height: "12px" }}
                />
              ) : (
                source
              )}
            </Typography> */}
          </>
        )}
      </Box>
      <RowContainer>
        {isLoading ? (
          <Skeleton variant="circular" width={20} height={20} />
        ) : (
          paitents === 0 && <CheckCircleIcon fontSize="small" />
        )}
        {isLoading ? (
          <Skeleton variant="text" width={60} height={20} />
        ) : (
          <PaitentContainer fontSize={12} fontWeight={400} color={"black"}>
            {paitents} Patients
          </PaitentContainer>
        )}
        {isLoading ? (
          <Skeleton variant="circular" width={40} height={40} />
        ) : (
          <Link
            to="/care-opportunity"
            state={{ title, data }}
            style={{ textDecoration: "none" }}
          >
            <IconButton>
              <KeyboardArrowRightIcon fontSize="large" />
            </IconButton>
          </Link>
        )}
      </RowContainer>
    </ContainerBox>
  );
};

export default Widget;
